// extracted by mini-css-extract-plugin
module.exports = {"IAndCLifecycleAdvisor":"IAndCLifecycleAdvisor_IAndCLifecycleAdvisor__7mPBm"};